export default {
  setNotifications({ commit }, notifications) {
    commit('setNotifications', notifications)
  },
  addNotification({ commit }, notification) {
    commit('addNotification', notification)
  },
}
